// import dayjs from 'dayjs';
import { override } from 'flarum/common/extend';
import PostStream from 'flarum/forum/components/PostStream';

const d = dayjs();
const count = Object.keys(d.__proto__).length;

/**
 * 处理flarum/core/js/common/utils/humanTime.ts内d.format('D MMM')
 * 中文下需要解析成xx月xx日
 */
function hackDMMM() {
  // @ts-ignore
  override(d.__proto__, 'format', function (format, template) {
    if (template === 'D MMM') {
      return format('MMMD日');
    }
    return format(template);
  });
}

/**
 * 某些安卓机企微内置浏览器下会报错
 * TypeError: dayjs(...).add(...).fromNow is not a function
 * TODO: 原因未知，表现为渲染的时候dayjs实例少了部分方法，没有安卓设备无法复现
 */
function hackAndroidWeComDayjsBug() {
  override(PostStream.prototype, 'view', function (original) {
    const newD = dayjs();
    const newCount = Object.keys(newD.__proto__).length;
    if (newCount < count) {
      Object.assign(newD.__proto__, d.__proto__);
    }
    return original();
  });
}

export default function () {
  hackDMMM();
  hackAndroidWeComDayjsBug();
}
